import { onlineManager, useMutation } from '@tanstack/react-query';
import { size } from 'lodash';
import login, { loginForm } from '../../api/mutations/login';
import { loginSuccess } from '../../redux/auth/authSlice';
import { useAppDispatch } from '../../redux/hooks';

const useLogin = () => {
  const dispatch = useAppDispatch();
  const { mutateAsync: loginUser, isPending } = useMutation({
    mutationKey: ['login'],
    mutationFn: (data: loginForm) => login(data),
    onMutate: () => {
      if (!onlineManager.isOnline()) {
        throw new Error('network_offline');
      }
    },
    onSuccess: (data) => {
      dispatch(
        loginSuccess({
          tokens: {
            accessToken: data.access_token,
            refreshToken: data.refresh_token,
          },
          user: {
            _id: data._id,
            country: data.country,
            email: data.email,
            avatar: data.avatar,
            name: data.name,
            roles: data.roles,
            devicePOS: data.devicePOS,
            emailVerified: data.emailVerified,
            userPosCount: data.userPosCount,
            userStores: data.userStores,
            activeStore: size(data.userStores) == 1 ? data.userStores?.[0] : null,
          },
        })
      );
      return data;
    },
    onError: (error) => {
      return error;
    },
  });
  return { loginUser, isPending };
};

export default useLogin;
